// @flow
import Box from '@mui/material/Box';

type Props = { children: any };
const PageContainer = ({ children }: Props): React$Node => {
  return <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', mt: 7 }}>{children}</Box>;
};

export default PageContainer;
